module.exports = __webpack_public_path__ + "static/media/alert.d9584c82.svg";